import React, { useEffect, useState, useRef } from "react";
import { observer, Observer } from "mobx-react";
import classNames from "classnames";
import { validResult, clearResult } from "./DilutionUtils";

function usePreventWindowUnload(preventDefault) {
  React.useEffect(
    () => {
      if (!preventDefault) return;
      const handleBeforeUnload = (event) => event.preventDefault();
      window.addEventListener("beforeunload", handleBeforeUnload);
      return () => window.removeEventListener("beforeunload", handleBeforeUnload);
    },
    [preventDefault]
  );
}

function UnsavedResultsNotification({ dilutionTests }) {
  const isEmpty =
    !dilutionTests ||
    dilutionTests.length === 0 ||
    dilutionTests.filter((dt) => validResult(dt)).length == 0;

  // usePreventWindowUnload(!isEmpty);

  if (isEmpty) {
    return null;
  }

  const unsavedResultCount = dilutionTests.filter((dt) => validResult(dt)).length;

  if (unsavedResultCount === 0) {
    return null;
  }

  return (
    <div
      className="alert alert-danger"
      style={{ display: "inline-block", marginLeft: 20, marginBottom: 0 }}
    >
      There are {unsavedResultCount} unsaved results on this page!
    </div>
  );
}

UnsavedResultsNotification = observer(UnsavedResultsNotification);

export default UnsavedResultsNotification;
